<template>
  <section class="gray-bg ">
    <div class="container">
      <div class="section-title st-center fl-wrap">
        <h4>Testimonials</h4>
        <h2>What Our Clients Say</h2>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="testimonials-slider-wrap">
      <el-carousel :interval="4000" type="card" height="200px">
        <el-carousel-item class="slick-item">
          <div class="text-carousel-item fl-wrap">
            <div class="text-carousel-item-header fl-wrap">
              <div class="popup-avatar">
<!--                <images src="../../assets/images/avatar/1.jpeg" alt="">-->
              </div>
              <div class="review-owner fl-wrap">
                Brian M.
              </div>
              <div class="listing-rating card-popup-rainingvis" data-starrating2="5"></div>
            </div>
            <div class="text-carousel-content fl-wrap">
              <p> "I own a property management agency and KODI has really changed the way I manage my properties.
                From managing bills, to service charges, Rent Collection, resolving tenant issues,KODI has me covered. I
                am even able to add more agents to help in property management seamlessly. Highly recommended."
              </p>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item class="slick-item">
          <div class="text-carousel-item fl-wrap">
            <div class="text-carousel-item-header fl-wrap">
              <div class="popup-avatar">
<!--                <images src="../../assets/images/avatar/1.jpeg" alt="">-->
              </div>
              <div class="review-owner fl-wrap">
                Joseph K.
              </div>
              <div class="listing-rating card-popup-rainingvis" data-starrating2="4"></div>
            </div>
            <div class="text-carousel-content fl-wrap">
              <p> "I have been looking for genuine houses for a long time. KODI provided me with agents that took me to
                view the houses they have posted on the website and I found a house within the same day. I don't mind
                paying the House Hunting Fee which was valid for 2 months."
              </p>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item class="slick-item">
          <div class="text-carousel-item fl-wrap">
            <div class="text-carousel-item-header fl-wrap">
              <div class="popup-avatar">
<!--                <images src="../../assets/images/avatar/1.jpeg" alt="">-->
              </div>
              <div class="review-owner fl-wrap">Karanja W.</div>
              <div class="listing-rating card-popup-rainingvis" data-starrating2="4"></div>
            </div>
            <div class="text-carousel-content fl-wrap">
              <p> "KODI gives me the freedom to advertise my properties at no additional cost which is really good. I
                would have hoped the verification process took a shorter time, but it's worth it because the platform is
                very strict on the houses and agents joining the platform. Thank you!"
              </p>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </section>
</template>

<script>
export default {
  name: "Testimonials"
}
</script>